import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import {get, post, put, patch, del} from './utils/http'
import './assets/css/main.css';
import './assets/css/style.scss';
import 'element-ui/lib/theme-chalk/index.css';
import elementUi from 'element-ui';
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import './assets/common.css'

const Base64 = require('js-base64').Base64;
Vue.use(elementUi);
Vue.use(VueVideoPlayer);

// Vue.prototype.BASEURL = 'http://127.0.0.1:8000/api/v1';
// Vue.prototype.BASEURL = 'https://ceshi.zikaoj.com:9088/api/v1';
Vue.prototype.BASEURL = 'https://crjyxspt.zikaoj.com/api/v1';

Vue.config.productionTip = false;
//定义全局变量封装axios的请求方法.
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$put = put;
Vue.prototype.$patch = patch;
Vue.prototype.$del = del;
Vue.prototype.$base64 = Base64;

axios.interceptors.request.use(
    config => {
        if (localStorage.my_token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = `${localStorage.my_token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
//页面切换默认滚动条回到0
router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
});
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
